import { createStore } from "vuex";
import etagStore from "./etagStore";
import companyStore from "./companyStore";
import studentStore from "./studentStore";
import meetingStore from "./meetingStore";

export default createStore({
  modules: {
    etag: etagStore,
    company: companyStore,
    student: studentStore,
    meeting: meetingStore,
  },
  state() {
    return {
      token: localStorage.getItem("token") || null,
      user: JSON.parse(localStorage.getItem("user")) || null,
    };
  },
  mutations: {
    setToken(state, token) {
      state.token = token;
      token
        ? localStorage.setItem("token", token)
        : localStorage.removeItem("token");
    },
    setUser(state, user) {
      state.user = user;
      user
        ? localStorage.setItem("user", JSON.stringify(user))
        : localStorage.removeItem("user");
    },
    updateInterestedCompanies(state, interestedCompanies) {
      if (state.user) {
        state.user.interestedCompanies = interestedCompanies;
        localStorage.setItem("user", JSON.stringify(state.user));
      }
    },
  },
  actions: {
    login({ commit }, { token, user }) {
      commit("setToken", token);
      commit("setUser", user);
    },
    logout({ commit }) {
      commit("setToken", null);
      commit("setUser", null);
      localStorage.removeItem("token");
      localStorage.removeItem("user");
    },

    updateInterestedCompanies({ commit }, interestedCompanies) {
      commit("updateInterestedCompanies", interestedCompanies);
    },
  },
  getters: {
    isLoggedIn(state) {
      return !!state.token;
    },
    user(state) {
      return state.user;
    },
  },
});
